/* global Liferay */

import { config, ENDPOINT } from "../utils/constants";
import { getServerUrl, oAuthRequest, request } from "../utils/request";
import { getCurrentSiteId, isSignedIn } from "../utils/util";

export const loadExerciseQuestions = (exerciseId) =>{
    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.EXERCISES}/${exerciseId}/questions?pageSize=100`,
        method:'get'
    });
}

export const getQuestions = async (exerciseId) => {
    try {
        const client = Liferay.OAuth2Client.FromUserAgentApplication(
            config.agentOauthSpringAppId
        );

        if (!isSignedIn()) {
            const response = await fetch(
                `${client.homePageURL}/learn/${exerciseId}/questions`
            );

            if (!response.ok) {
                throw new Error(`HTTP error - Status: ${response.status}`);
            }

            return await response.json();
        }

        return await client.fetch(`/learn/${exerciseId}/questions`);
    } catch (error) {
        console.error("Error fetching questions:", error);
        throw error;
    }
};

export const postQuizResult = async (exerciseId, answersData) => {
    try {
        const client = Liferay.OAuth2Client.FromUserAgentApplication(
            config.agentOauthSpringAppId
        );

        if (!isSignedIn()) {
            const response = await fetch(
                `${client.homePageURL}/learn/${exerciseId}/result`,
                {
                    body: JSON.stringify(answersData),
                    headers: {
                        "Content-Type": "text/json",
                    },
                    method: "POST",
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            return await response.json();
        }

        const response = await client.fetch(`/learn/${exerciseId}/result`, {
            body: JSON.stringify(answersData),
            headers: {
                "Content-Type": "text/json",
            },
            method: "POST",
        });

        return response;
    } catch (error) {
        console.error("Error posting quiz result:", error);
        throw error;
    }
};

export const getQuiz = (exerciseId) =>{
    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.EXERCISES}/${exerciseId}`,
        method:'get'
    });

}

export const getQuizByDPAAssetId = async (DPTAssetId) => {
    return Liferay.Util.fetch(`${ENDPOINT.QUIZZES}/${DPTAssetId}`)
            .then((response) => response.json())
}

export const postExerciseResult = async (exerciseId,answersData) =>{
    let serviceBaseAddress = getServerUrl();

    return await request({
        url:`${serviceBaseAddress}${ENDPOINT.EXERCISES}/${exerciseId}/result`,
        method:'post',
        data:{
            answers:answersData,
            scopeId : getCurrentSiteId()
        }
    });
}

